<template>
  <div class="vocab locale">
    <!-- TODO -->
  </div>
</template>

<script>
  /**
   * ### Locale brings the content to you.
   *
   * When exploring an app that has translations defined, the user can
   * switch between locales using this component.
   */
  export default {
    name: 'Locale'
  }
</script>
